const React = require('react');
const withState = require('../../../../utils/withState');
const {
  loadingReconnect$,
} = require('../../../../api/_auth');
const {
  account$,
} = require('../../../../emitters/account');
const {mobile$} = require('../../../../emitters/mobile');

const DesktopLayout = require('./DesktopLayout');
const MobileLayout = require('./MobileLayout');

module.exports = withState(() => {
  return (state, props) => {
    const Wrapper = state.mobile ? MobileLayout : DesktopLayout;
    return (
      <Wrapper>
        {props.children}
      </Wrapper>
    );
  };
}, {
  mobile: mobile$,
  loadingReconnect: loadingReconnect$,
  account: account$,
});
